import { Button } from 'bzx-common/src/ui-framework'
import React, { Component } from 'react'

export interface IInfoBlockProps {
  className?: string
  /** The key under which the flag is set in local storage when the user accepts */
  storageKey: string
  onAccept?: () => void
}
export interface IInfoBlockState {
  hasAccepted: boolean
}

class InfoBlock extends Component<IInfoBlockProps, IInfoBlockState> {
  constructor(props: IInfoBlockProps, context?: any) {
    super(props, context)

    const localStorageItem = localStorage.getItem(this.props.storageKey)
    this.state = { hasAccepted: !!localStorageItem }
  }

  onAccept = () => {
    localStorage.setItem(this.props.storageKey, 'true')
    this.setState({ hasAccepted: true })
    if (this.props.onAccept) {
      this.props.onAccept()
    }
  }

  public render() {
    if (this.state.hasAccepted) {
      return null
    }

    return (
      <div className={`note--warning padded-v-05 padded-h-1 ${this.props.className || ''}`}>
        <div className="flex-row-center justify-between">
          <div>{this.props.children}</div>
          {!this.state.hasAccepted && (
            <div className="">
              <Button variant="blue" className="btn--responsive" onClick={this.onAccept}>
                ok
              </Button>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default InfoBlock
